import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { useState } from 'react';

const LOGO_WHITE_BG = "https://customer-assets.emergentagent.com/job_quick-cab-booking/artifacts/zydgwvt1_13cabsbook%20logo%20short.png";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleBookNowClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    
    if (location.pathname === '/') {
      // Already on home page, scroll to booking section
      const bookingSection = document.getElementById('booking');
      if (bookingSection) {
        bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Navigate to home page then scroll to booking
      navigate('/');
      setTimeout(() => {
        const bookingSection = document.getElementById('booking');
        if (bookingSection) {
          bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/fleet', label: 'Our Fleet' },
    { href: '/airport-transfers', label: 'Airport Transfers' },
    { href: '/corporate', label: 'Corporate' },
    { href: '/events', label: 'Events' },
    { href: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-secondary/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="header-logo">
            <img src={LOGO_WHITE_BG} alt="13cabsbook" className="h-14 md:h-16 object-contain" />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive(link.href) ? 'text-primary' : 'text-white hover:text-primary'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <a 
              href="tel:1300096685" 
              className="flex items-center gap-2 text-white hover:text-primary transition-colors duration-200"
              data-testid="header-phone"
            >
              <Phone className="w-4 h-4" />
              <span className="hidden md:inline font-medium">1300 096 685</span>
            </a>
            <button 
              onClick={handleBookNowClick}
              className="hidden sm:block bg-primary hover:bg-primary-hover text-white px-4 py-2 rounded-lg font-semibold transition-colors duration-200"
              data-testid="header-book-btn"
            >
              Book Now
            </button>
            
            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-white/10 pt-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-sm font-medium py-2 transition-colors duration-200 ${
                    isActive(link.href) ? 'text-primary' : 'text-white hover:text-primary'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <button
                onClick={handleBookNowClick}
                className="bg-primary hover:bg-primary-hover text-white px-4 py-2 rounded-lg font-semibold text-center mt-2 transition-colors duration-200"
              >
                Book Now
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
